import * as React from 'react';
export var DropdownIcon = function (_a) {
    var _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.strokeColor, strokeColor = _c === void 0 ? '#6B7280' : _c;
    return (React.createElement("svg", { className: "dropdownIcon ".concat(className), width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M12.6666 6L7.99992 10.6667L3.33325 6", stroke: strokeColor, strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })));
};
